import { StrictMode } from 'react'
import './i18n'
import { createRoot } from 'react-dom/client'
// Self-hosted Inter (variable). Same typeface as before, but bundled via
// Fontsource so there's no render-blocking Google Fonts link or font flash.
import '@fontsource-variable/inter'
// Remix Icon webfont (ri-* glyphs). Was never loaded before, so every
// ri-* icon across the site rendered as an empty box. Self-hosted here.
import 'remixicon/fonts/remixicon.css'
import './index.css'
import App from './App.tsx'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
